<template>
    <div>
        <span class="block text-center text-2xl font-bold mb-8">{{ $t('grant') }}</span>
        <vs-checkbox v-model="holder_of_grant" :disabled="disabled">
            {{ $t('holder_of_grant') }}
        </vs-checkbox>
        <template v-if="holder_of_grant">
            <form data-vv-scope="grant">
                <div :class="classForDOM.parent">
                    <div :class="classForDOM.block">
                        <MultiselectCustom endpoint="admissions/grant-types/"
                                           :disabled="disabled"
                                           name="type"
                                           v-validate="'required'"
                                           :placeholder="`${ $t('type') }*`"
                                           v-model="grant.type"/>
                        <ValidateText field="type" scope="grant" :error="errors"/>
                    </div>
                </div>
                <div :class="classForDOM.parent">
                    <div :class="classForDOM.block">
                        <MultiselectCustom endpoint="organizations/edu-program-groups/"
                                           name="education_program_group"
                                           :disabled="disabled"
                                           v-validate="'required'"
                                           :placeholder="`${ $t('education_program_group') }*`"
                                           v-model="grant.education_program_group"/>
                        <ValidateText field="education_program_group" scope="grant" :error="errors"/>
                    </div>
                </div>
                <div :class="classForDOM.parent">
                    <div :class="classForDOM.block">
                        <DatepickerCustom v-model="grant.start_date"
                                          name="start_date"
                                          :disabled="disabled"
                                          v-validate="'required'"
                                          :placeholder="`${ $t('start_date') }*`"/>
                        <ValidateText field="start_date" scope="grant" :error="errors"/>
                    </div>
                    <div :class="classForDOM.block">
                        <DatepickerCustom v-model="grant.end_date"
                                          name="end_date"
                                          :disabled="disabled"
                                          v-validate="'required'"
                                          :placeholder="`${ $t('end_date') }*`"/>
                        <ValidateText field="end_date" scope="grant" :error="errors"/>
                    </div>
                </div>
                <div :class="classForDOM.parent">
                    <div :class="classForDOM.block">
                        <DatepickerCustom v-model="grant.issued_at"
                                          name="issued_at"
                                          :disabled="disabled"
                                          v-validate="'required'"
                                          :placeholder="`${ $t('issued_at') }*`"/>
                        <ValidateText field="issued_at" scope="grant" :error="errors"/>
                    </div>
                    <div :class="classForDOM.block">
                        <DatepickerCustom v-model="grant.date_of_order"
                                          name="date_of_order"
                                          :disabled="disabled"
                                          v-validate="'required'"
                                          :placeholder="`${ $t('date_of_order') }*`"/>
                        <ValidateText field="date_of_order" scope="grant" :error="errors"/>
                    </div>
                </div>
                <div :class="classForDOM.parent">
                    <div :class="classForDOM.block">
                        <vs-input :label-placeholder="`${ $t('order_number_grant') }*`"
                                  v-validate="'required'"
                                  name="order_number_grant"
                                  :disabled="disabled"
                                  v-model="grant.order_number"
                                  class="mt-8 flex-auto p-1 w-full"/>
                        <ValidateText field="order_number_grant" scope="grant" :error="errors"/>
                    </div>
                    <div :class="classForDOM.block">
                        <vs-input :label-placeholder="`${ $t('series_grant') }*`"
                                  v-validate="'required'"
                                  name="series_grant"
                                  v-model="grant.series"
                                  :disabled="disabled"
                                  class="mt-8 flex-auto p-1 w-full"/>
                        <ValidateText field="series_grant" scope="grant" :error="errors"/>
                    </div>
                    <div :class="classForDOM.block">
                        <vs-input :label-placeholder="`${ $t('number_grant') }*`"
                                  v-validate="'required'"
                                  name="number_grant"
                                  :disabled="disabled"
                                  v-model="grant.number"
                                  class="mt-8 flex-auto p-1 w-full"/>
                        <ValidateText field="number_grant" scope="grant" :error="errors"/>
                    </div>
                </div>
                <template v-if="file_upload_limitation">
                    <span class="text-base font-medium pt-4 block pl-2">{{ $t('upload_the_required_documents') }}*</span>
                    <span v-if="!grant.files.length" class="pl-2 text-danger" >{{ $t('please_add_files') }}</span>
                    <div :class="classForDOM.parent">
                        <vs-upload
                            :text="$t('upload_file')"
                            :action="'common/upload/'"
                            :disabled="disabled"
                            @on-success="setGrantFiles"
                            @prev-delete="removeGrantFile"
                            :single-upload="true"
                            :firstFiles="grant.files"
                            :automatic="true"
                            :max-size="file_upload_limitation['max_file_size']"
                            :fileName="'path'"
                        />
                    </div>
                </template>
            </form>
        </template>
        <vs-alert :title="$t('remark')"
                  v-else
                  active="true"
                  color="dark"
                  class="mt-4">
            {{ $t('grant_not_required') }}
        </vs-alert>
    </div>
</template>

<script>
import MultiselectCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/MultiselectCustom";
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
import DatepickerCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/DatepickerCustom";
export default {
    name: "Grants",
    props: {
        data: {
            type: Object,
            required: true,
        },
        file_upload_limitation: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        MultiselectCustom,
        ValidateText,
        DatepickerCustom
    },
    data(){
        return {
            holder_of_grant: !!this.data.grant,
            grant: {
                profile: this.data.profile.uid,
                type: '',
                start_date: '',
                end_date: '',
                issued_at: '',
                series: '',
                number: '',
                date_of_order: '',
                order_number: '',
                education_program_group: '',
                files: [],
                uid: null,
            },
            classForDOM: {
                grandParent: 'flex flex-col md:flex-row justify-between',
                parent: 'flex flex-col md:flex-row justify-between items-start',
                block: 'flex flex-col w-full',
            },
        }
    },
    methods: {
        setGrantFiles(response){
            if (!this.grant.files) this.grant.files = [];
            if (this.grant.files.findIndex(({ name }) => name === response[0].name)){
                const firstFiles = this.grant.files.filter((i) => i.firstFile || i.name !== response[0].name);
                const newFiles = response.map((item) => {
                    return {
                        ...item,
                        response: item,
                    };
                });
                this.grant.files = firstFiles.concat(newFiles);
            } else {
                this.grant.files = this.grant.files.concat(
                    response.map((item) => {
                        return {
                            ...item,
                            response: item,
                        };
                    })
                );
            }
        },
        async removeGrantFile({ file, done }){
            this.grant.files = await this.grant.files.filter((item) => item.response.uid !== file.response.uid);
            done();
        },
        async saveGrant(){
            try {
                this.$vs.loading();

                const newGrant = this.grant?.uid;

                let clone = { ...this.grant };

                clone.files = clone.files.map(e => e.response.uid);

                const response = (await this.$http[newGrant ? 'patch' : 'post'](
                    `admissions/grant-certificates/${ newGrant ? newGrant + '/' : '' }`,
                    clone
                )).data;

                this.grant.uid = response.uid;

                this.$emit('setNewDataInObject', {
                    name: 'grant',
                    data: this.grant,
                })

            } catch (e){

            } finally {
                this.$vs.loading.close();
            }
        },
        async removeGrant(){
            try {
                this.$vs.loading();

                (await this.$http.delete(`admissions/grant-certificates/${ this.grant.uid }/`)).data

                this.$emit('setNewDataInObject', {
                    name: 'grant',
                    data: null,
                })

            } catch (e){

            } finally {
                this.$vs.loading.close();
            }
        },
        validateStep(){
            if (!this.disabled){
                return this.$validator.validateAll('grant').then(async (result) => {
                    if (!this.holder_of_grant){
                        return true
                    } else {
                        if (result) {
                            // Делаю запросы на сохранение и пропускаю клиента на следующий шаг
                            await this.saveGrant();

                            await this.$emit('setNewDataInObject', {
                                name: 'grant',
                                data: this.grant,
                            });

                            return true
                        }
                        else
                            return false
                    }
                })
            } else {
                return true
            }
        }
    },
    created() {
        if (this.data.grant){
            const grant = this.data.grant;

            for (let key in this.grant){
                if(key === 'files'){
                    this.grant['files'] = grant.files.map(f => {
                        return {
                            ...f,
                            response: f,
                            firstFiles: true
                        }
                    })
                } else {
                    this.grant[key] = grant[key]
                }
            }
        }
    },
    watch: {
        'holder_of_grant'(){
            if(!this.holder_of_grant) {
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: this.$t('attention'),
                    text: this.$t('youDeletedGrantText'),
                    accept: () => {
                        this.removeGrant()
                        for (let key in this.grant){
                            if(key === 'files'){
                                this.grant.files = []
                            } else if (key !== 'profile'){
                                this.grant[key] = '';
                            }
                        }
                    },
                    acceptText: this.$t('i_agree'),
                    cancelText: this.$t('i_changed_my_mind'),
                    cancel: () => {
                        this.holder_of_grant = true;
                    }
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
